import {connect} from 'react-redux';
import { findIndex } from 'lodash';
import {ResultsComparisonGel as Component} from './ResultsComparisonGel';
import {} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  return {
    gelDragDropPrediction: state.notebook.levelData.GENERIC_CHAPTERS.PREDICTIONS.components[findIndex(state.notebook.levelData.GENERIC_CHAPTERS.PREDICTIONS.components, {type: "GEL_DRAG_DROP_QUESTION"})],
    interactionProps: {
      solutions: state.notebook.protocolSection.scene.apparatus.solutions,
      agaroseGel: state.notebook.protocolSection.scene.apparatus.agaroseGel
    },
    level: state.notebook.levelSelected.id,

    //TODO: Fix these project specific dependencies
    //gelExamined: state.notebook.protocolSection.scene.apparatus.transilluminator[0].gelExamined,
    gelOrientation: state.notebook.protocolSection.scene.apparatus.gelBoxes[0].gelOrientation
  }

}

function mapDispatchToProps(dispatch) {
  return {};
}

export const ResultsComparisonGel = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
